import { Database, Server, Radio } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";

const VENDORS = [
    {
        icon: Database,
        name: "Cloudera",
        tag: "Hybrid Data Platform",
        body: "Cloudera empowers organizations to transform complex data into actionable insight through a secure, scalable, open data platform. With CDP, enterprises manage and analyze data across hybrid and multi-cloud environments with unified security, governance and control.",
    },
    {
        icon: Server,
        name: "Hewlett Packard Enterprise",
        tag: "HPC & Supercomputing",
        body: "HPE is a global leader in high-performance computing, delivering cutting-edge systems that solve complex scientific, engineering and data-intensive challenges, from AI and machine learning to climate modeling and genomics at scale.",
    },
    {
        icon: Radio,
        name: "Confluent",
        tag: "Real-Time Data Streaming",
        body: "Built on Apache Kafka, Confluent enables real-time data movement across cloud and on-premises environments. Connect applications, systems and data sources to power modern, event-driven architectures and AI/ML integration.",
    },
];

const BADGES = ["NVIDIA", "AWS", "Microsoft Azure", "Google Cloud", "Red Hat", "Kubernetes"];

export const Vendors = () => (
    <section id="partners" data-testid="vendors-section" className="relative py-24 sm:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <Reveal className="max-w-2xl">
                <Eyebrow>Vendors</Eyebrow>
                <h2 className="mb-4 font-syne text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="vendors-heading">
                    Our leading vendors for smarter solutions
                </h2>
            </Reveal>

            <div className="mt-12 grid gap-4 lg:grid-cols-3">
                {VENDORS.map((v, i) => (
                    <Reveal key={v.name} delay={i * 0.12}>
                        <div
                            data-testid={`vendor-card-${i}`}
                            className="card-glow-border group flex h-full flex-col rounded-2xl border border-white/[0.08] bg-card2/50 p-8"
                        >
                            <div className="mb-6 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-volt/20 bg-volt/10 text-volt transition-all duration-500 group-hover:scale-110">
                                <v.icon size={22} />
                            </div>
                            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-volt">{v.tag}</div>
                            <h3 className="mb-3 mt-1.5 font-syne text-xl font-semibold text-white">{v.name}</h3>
                            <p className="text-sm leading-relaxed text-slate-400">{v.body}</p>
                        </div>
                    </Reveal>
                ))}
            </div>

            <Reveal delay={0.2}>
                <div className="mt-10 flex flex-wrap items-center gap-3" data-testid="vendor-badges">
                    <span className="mr-2 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-500">
                        Integration ecosystem
                    </span>
                    {BADGES.map((b) => (
                        <span
                            key={b}
                            className="rounded-full border border-white/10 bg-white/[0.03] px-4 py-2 font-mono text-[11px] uppercase tracking-[0.15em] text-slate-300 transition-colors duration-300 hover:border-volt/40 hover:text-volt"
                        >
                            {b}
                        </span>
                    ))}
                </div>
            </Reveal>
        </div>
    </section>
);
